import { initComponent } from './core/init-component';
import Swiper from 'swiper';
import { Mousewheel } from 'swiper/modules';

initComponent('.js-ls-product-grid', (el) => {
  if (el.dataset.type !== 'carousel') return;

  // A carousel may be scoped to a single breakpoint (when mobile/desktop layouts
  // differ). Swiper miscalculates widths on a display:none element, so only run
  // it while its breakpoint is active.
  const bp = el.dataset.breakpoint;
  const mq =
    bp === 'desktop' ? window.matchMedia('(min-width: 1024px)')
    : bp === 'mobile' ? window.matchMedia('(max-width: 1023px)')
    : null;

  // Optional trailing space (px) after the last slide, so it isn't flush
  // against the container edge.
  const offsetAfter = Number(el.dataset.offsetAfter) || 0;

  let swiper: Swiper | undefined;

  const allowPinchZoom = (event: TouchEvent) => {
    if (event.touches.length < 2) return;
    swiper && (swiper.allowTouchMove = false);
    event.stopImmediatePropagation();
  };

  const restoreSwiperTouch = () => {
    swiper && (swiper.allowTouchMove = true);
  };

  el.addEventListener('touchstart', allowPinchZoom, { capture: true, passive: true });
  el.addEventListener('touchmove', allowPinchZoom, { capture: true, passive: true });
  el.addEventListener('touchend', restoreSwiperTouch, { passive: true });
  el.addEventListener('touchcancel', restoreSwiperTouch, { passive: true });

  const sync = () => {
    const shouldRun = !mq || mq.matches;
    if (shouldRun && !swiper) {
      swiper = new Swiper(el, {
        modules: [Mousewheel],
        slidesPerView: 'auto',
        spaceBetween: 2,
        slidesOffsetAfter: offsetAfter,
        grabCursor: true,
        mousewheel: { forceToAxis: true },
        touchStartPreventDefault: false,
        speed: 125,
        longSwipesRatio: 0.5,
        on: {
          setTransition(s) {
            s.wrapperEl.style.transitionTimingFunction = 'var(--ease-both)';
          },
        },
      });
    } else if (!shouldRun && swiper) {
      swiper.destroy(true, true);
      swiper = undefined;
    }
  };

  sync();
  mq?.addEventListener('change', sync);

  return {
    unload() {
      el.removeEventListener('touchstart', allowPinchZoom, { capture: true });
      el.removeEventListener('touchmove', allowPinchZoom, { capture: true });
      el.removeEventListener('touchend', restoreSwiperTouch);
      el.removeEventListener('touchcancel', restoreSwiperTouch);
      mq?.removeEventListener('change', sync);
      swiper?.destroy(true, true);
    },
  };
});
